import Crud from '../views/Monitoring/Crud'

let routes = {
    path: '/monitorings',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/monitorings',
            name: 'list-monitorings',
            component: Crud,
            meta: {
                ability: 'eventos.ver',
                pageTitle: 'Monitoring',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
